import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchDailyRecordsSuccess, fetchDailyRecordsFailure } from "./actions";
import { FETCH_DAILY_RECORDS } from "./constants";

export function* fetchDailyRecordsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { locationId, date } = payload || {};
  const query = date ? `?date=${encodeURIComponent(date)}` : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/location/${locationId}/observations${query}`,
    );
    // apiResponse wraps the body as { status, data: {...}, message }. Be
    // tolerant of an un-enveloped body, and of a bare array of groups.
    const raw = data?.data ?? data ?? {};
    const body = Array.isArray(raw) ? { residents: raw } : raw;
    const groups = Array.isArray(body?.residents) ? body.residents : [];
    const summary =
      body?.summary &&
      typeof body.summary === "object" &&
      !Array.isArray(body.summary)
        ? body.summary
        : null;
    yield put(
      fetchDailyRecordsSuccess({
        date: body?.date ?? date ?? null,
        locationId: locationId ?? null,
        residents: groups,
        summary,
        fetchedAt: new Date().toISOString(),
      }),
    );
  } catch (e) {
    yield put(fetchDailyRecordsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e?.error === "string") yield put(errorAlert(e.error));
    else yield put(errorAlert("Error while loading the daily records."));
  }
}

export function* fetchDailyRecordsFlow() {
  // Latest wins: flicking through days fires a fetch per click, and an older
  // day's response must never land after (and over) the day on screen.
  yield takeLatest(FETCH_DAILY_RECORDS, fetchDailyRecordsSaga);
}

export default function* DailyRecordsSaga() {
  yield all([fetchDailyRecordsFlow()]);
}
